



































































import { Component, Vue } from 'vue-property-decorator'
import { User } from './types/Users'

import Toolbar from '@/layouts/Toolbar.vue'
import NavDrawer from '@/layouts/NavDrawer.vue'
import WorxstrFooter from '@/layouts/Footer.vue'
import MessageSnackbar from '@/layouts/MessageSnackbar.vue'
import { Capacitor } from '@capacitor/core'
import { Network } from '@capacitor/network'
import { environment, sandboxMode } from './services/app'
import AppUpdateDialog from '@/views/AppUpdateDialog.vue'

@Component({
  metaInfo: {
    titleTemplate: '%s | Worxstr',
    meta: [
      {
        name: 'description',
        content: 'The adaptive solution to wide-scale temp labor management.',
      },
    ],
  },
  components: {
    Toolbar,
    NavDrawer,
    WorxstrFooter,
    MessageSnackbar,
    AppUpdateDialog,
  },
})
export default class App extends Vue {
  drawer = false
  stylesLoaded = false
  offline = false

  // Wait for external styles to load to compute safe areas
  created() {
    window.addEventListener('load', () => {
      this.stylesLoaded = true
    })
    // Sometimes that doesn't work. So for the next 8 seconds we will recompute the value
    // This is the most bullshit way to do this but it works
    for (let i = 0; i < 13; i++) {
      setTimeout(() => {
        this.stylesLoaded = false
        this.stylesLoaded = true
      }, 2 ** i)
    }

    Network.addListener('networkStatusChange', status => {
      this.offline = !status.connected
    })

    this.shouldShowWatermark() // Initialize watermark
    environment.on('baseUrlChanged', () => {
      this.shouldShowWatermark()
    })
  }

  get env() {
    return process.env.VUE_APP_TEST_MODE
  }

  get me(): User {
    return this.$store.getters.me
  }

  get showUnverifiedWarning() {
    return !this.$store.getters.iAmVerified && this.$store.getters.me && !this.$route.meta?.landing
  }

  get showNavDrawer() {
    return !this.$route.meta?.landing && !this.$route.meta?.noSkeleton
  }

  get showHeader() {
    return !this.$route.meta?.noSkeleton
  }

  get showFooter() {
    return this.isLanding && !Capacitor.isNativePlatform()
  }

  get isLanding() {
    return !!this.$route.meta?.landing
  }

  get headerHeight() {
    if (!this.showHeader) return 0
    return !this.mobileLayout ? 64 : 56
  }
  footerHeight = 56

  get pageHeight() {
    const viewportHeight =  `calc(100vh - ${this.headerHeight +
                                            this.safeAreaTop +
                                            this.safeAreaBottom}px)`
    this.setCSSVariable('page-height', viewportHeight)
    
    // Normal view
    if (!this.$route.meta?.fullHeight || this.$route.meta?.noSkeleton) {
      return '100%'
    }
    // Full height, bottom nav hidden
    else {
      return viewportHeight
    }
  }

  setCSSVariable(key: string, val: string) {
    document.documentElement.style.setProperty(`--${key}`, val)
  }

  get mobileLayout() {
    return this.$vuetify.breakpoint.smAndDown
  }

  // Get safe area values from css definitions
  get safeAreaTop() {
    if (!this.stylesLoaded) return 0
    return parseInt(
      getComputedStyle(document.documentElement)
        .getPropertyValue('--sat')
        .replace('px', '')
    )
  }
  get safeAreaBottom() {
    if (!this.stylesLoaded || this.$route.meta?.bleedSafeAreaBottom) return 0
    return parseInt(
      getComputedStyle(document.documentElement)
        .getPropertyValue('--sab')
        .replace('px', '')
    )
  }

  get topMargin() {
    if (!this.mobileLayout || this.isLanding) {
      const val = this.headerHeight + this.safeAreaTop
      this.setCSSVariable('top-margin', val + 'px')
      return val
    }
    this.setCSSVariable('top-margin', this.safeAreaTop + 'px')
    return this.safeAreaTop
  }

  get bottomMargin() {
    if (this.mobileLayout && !this.isLanding) {
      return this.headerHeight + this.safeAreaBottom
    }
    return this.safeAreaBottom
  }

  get appUpdateDialog() {
    return this.$store.state.app.appUpdateDialog
  }

  showWatermark = false
  shouldShowWatermark() {
    const noWatermark = JSON.parse(window.localStorage.getItem('noWatermark') || 'false')
    const isTestSite = window.location.href.includes('test.worxstr.com')
    const isSandbox = sandboxMode.getStoredPreference()
    this.showWatermark = (isTestSite || isSandbox) && !noWatermark
  }
}
